import { ROW_GUTTER, VALIDATE_REQUIRED } from '@/config';
import { SoftwareComponentType, SystemAppType } from '@/constants';
import MainContent from '@/layouts/MainContent';
import { Button, Checkbox, Col, Divider, Form, Input, InputNumber, message, Radio, Row } from 'antd';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import './styles.less';
import { SaveOutlined } from '@ant-design/icons';
import { exportService } from '@/services/exportService';
import ExportBtn from '@/components/app/ExportBtn';
import ExportColumnsSelectorModal from '@/components/modals/ExportColumnsSelectorModal';
import { apiSdk } from '@/httpClient';

const PAGE_TITLE = 'softwareComponentsPage_Title';

export default function SoftwareComponentsPage() {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState<boolean>(false);
  const [exportColumns, setExportColumns] = React.useState<string[]>([]);
  const [showExportModal, toggleExportModal] = React.useState<boolean>(false);

  React.useEffect(() => {
    apiSdk.SoftwareComponentService.getExportColumns().then(res => {
      setExportColumns(res);
    });
  }, []);
  const onExportExcel = (cols: string[]) => {
    exportService
      .exportSoftwareComponents({
        columns: cols,
      })
      .toExcel();
  };
  const onExportPdf = (cols: string[]) => {
    exportService
      .exportSoftwareComponents({
        columns: cols,
      })
      .toPdf();
  };

  React.useEffect(() => {
    setLoading(true);
    apiSdk.SoftwareComponentService.getSoftwareComponentsForUpdate()
      .then(res => {
        form.setFieldsValue({
          components: res,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);
  const onSave = () => {
    form.validateFields().then(vallues => {
      setLoading(true);
      apiSdk.SoftwareComponentService.updateSoftwareComponents({
        body: {
          components: vallues.components,
        },
      })
        .then(response => {
          if (!response?.success) {
            message.error(t(response.message || ''));
          }
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };
  return (
    <MainContent
      title={t(PAGE_TITLE)}
      isLoading={loading}
      extraBtns={
        <ExportBtn
          disabled={!exportColumns?.length}
          onClick={() => {
            toggleExportModal(true);
          }}
        />
      }
    >
      <Helmet title={t(PAGE_TITLE)} />
      <div className="ant-layout-content-body" id="softwareComponentsPage">
        <div style={{ maxWidth: 1200, marginBottom: 20 }}>
          <Form form={form} size="middle" layout="vertical" onFinish={onSave}>
            <Row>
              <Button type="primary" onClick={onSave} icon={<SaveOutlined />}>
                {t('save')}
              </Button>
            </Row>
            <Row gutter={ROW_GUTTER} className="components-row-header">
              <Col md={6}>
                <b>{t('softwareComponentsPage_ComponentName')}</b>
              </Col>

              <Col md={5}>
                <b>{t('softwareComponentsPage_ComponentType')}</b>
              </Col>
              <Col md={3}>
                <b>{t('softwareComponentsPage_Price')}</b>
              </Col>
              <Col md={10}>
                <b>{t('softwareComponentsPage_AvailableApps')}</b>
              </Col>
            </Row>
            <Form.List name="components">
              {fields => {
                return fields.map(field => {
                  return (
                    <Row gutter={ROW_GUTTER} key={field.key} className="components-row-item">
                      <Col md={6}>
                        <Form.Item name={[field.name, 'id']} noStyle>
                          <Input type="hidden" />
                        </Form.Item>
                        <Form.Item name={[field.name, 'name']} noStyle>
                          <Input disabled className="input-value-color cpn-name" />
                        </Form.Item>
                      </Col>

                      <Col md={5} style={{ textAlign: 'center' }}>
                        <Form.Item name={[field.name, 'componentType']}>
                          <Radio.Group>
                            <Radio.Button value={SoftwareComponentType.Basic}>{t('Basic')}</Radio.Button>
                            <Radio.Button value={SoftwareComponentType.Optional}>{t('Optional')}</Radio.Button>
                          </Radio.Group>
                        </Form.Item>
                      </Col>
                      <Col md={3}>
                        <Form.Item name={[field.name, 'price']} rules={[{ required: true, message: VALIDATE_REQUIRED }]}>
                          <InputNumber min={0} className="w-100" />
                        </Form.Item>
                      </Col>
                      <Col md={10}>
                        <Form.Item name={[field.name, 'availableApps']}>
                          <Checkbox.Group options={SystemAppType.__getSelectOptions()}></Checkbox.Group>
                        </Form.Item>
                      </Col>
                    </Row>
                  );
                });
              }}
            </Form.List>
          </Form>
          <Divider />
          <Row>
            <Button type="primary" onClick={onSave} icon={<SaveOutlined />}>
              {t('save')}
            </Button>
          </Row>
        </div>
      </div>
      {showExportModal ? (
        <ExportColumnsSelectorModal
          title={t('passengerPage_ExportUtilityPartners')}
          onClose={() => toggleExportModal(false)}
          columns={exportColumns}
          onExportExcel={onExportExcel}
          onExportPdf={onExportPdf}
        />
      ) : null}
    </MainContent>
  );
}
